import script from "./ServiceProvider.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceProvider.vue?vue&type=script&setup=true&lang=js"

import "./ServiceProvider.vue?vue&type=style&index=0&id=ad3be46c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad3be46c"]])

export default __exports__